import { render, staticRenderFns } from "./delivery-order-export.vue?vue&type=template&id=add51964&scoped=true&"
import script from "./delivery-order-export.vue?vue&type=script&lang=js&"
export * from "./delivery-order-export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add51964",
  null
  
)

export default component.exports